import React, {Component} from "react";
import Dialog from "./Dialog";
import MfwSuccess from "../controllers/MfwSuccess";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/24/outline";

const MFWSuccessDialog: React.FC<{
    data: MfwSuccess[] | null
    close: () => void 
}> = (props) => {
    function mapSuccessAndFailed(condition: (s: MfwSuccess) => boolean, emptyMessage: string, icon: React.JSX.Element) {
        if (props.data == null) return []
        const filter = props.data.filter(condition)
            .map(s => s.message);
        if (filter.length == 0)
            return <div className={"flex items-center text-xs text-wrap"}>{emptyMessage}</div>
        return filter
            .map(s => <div className={"flex items-center text-xs text-wrap"}>
                {icon}
                <div>{s}</div>
            </div>)
    }

    function getSuccess() {
        return mapSuccessAndFailed(
            s => s.status,
            "Nothing successful",
            <CheckCircleIcon className="h-5 w-5 text-primary" aria-hidden="true"/>
        )
    }
    function getFailed() {
        return mapSuccessAndFailed(
            s => !s.status,
            "Nothing failed",
            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true"/>
        )
    }
    
    return <Dialog title={"Posted to MFW"}
                   setShow={() => props.close()}
                   show={props.data != null && props.data.length > 0}>
        <div className={"max-w-40 p-2"}>
            <div className={"pb-1 font-bold font-sm"}>Success:</div>
            {
                getSuccess()
            }
            <div className={"py-1 font-bold font-sm"}>Failed:</div>
            {
                getFailed()
            }
        </div>
    </Dialog>
}

export default MFWSuccessDialog;